module.exports = __webpack_public_path__ + "media/assets/logo/Logo_SemFundo_Agrosim_bem_reduzido-8499e332944ad93ce9873448dcf8ee58.png";